module.exports = {
	"WORKSPACE": {
		"PAGE_TITLE": "Workspace - Mobile Carwash Service",
		"CLIENT_NAME": "Workspace",
		"CLIENT_PREFIX": "WKS",
		"PAYMENT_TYPE": "PRE",
		"LOGO_PATH": "./workspace/logo.svg"
	},
	"FLEETPLUS": {
		"PAGE_TITLE": "FleetPlus - Mobile Carwash Service",
		"CLIENT_NAME": "FleetPlus",
		"CLIENT_PREFIX": "FP",
		"PAYMENT_TYPE": "PRE",
		"LOGO_PATH": "./fleetplus/logo.svg"
	},
	"MCCARROLLS": {
		"PAGE_TITLE": "Maserati McCarroll's - Mobile Carwash Service",
		"CLIENT_NAME": "McCarrolls",
		"CLIENT_PREFIX": "MC",
		"PAYMENT_TYPE": "PRE",
		"FAVICON_PATH": "./mccarrolls/favicon.ico",
		"AVAILABLE_WASH_TYPES": [
			"SPECTO",
			"TODO IMPLEMENT"
		],
		"LOGO_PATH": "./mccarrolls/logo.png",
		"ALLOWED_WASH_TYPES": [
			"SPECTO"
		]
	},
	"CARPARKS": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparks",
		"CLIENT_PREFIX": "CP",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "./carparks/icon.png"
	},
	"DOMAIN": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkDomain",
		"CLIENT_ID": "10074",
		"CLIENT_PREFIX": "CPDOM",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"ADDRESS": "Domain Car Park, woolloomooloo, NSW, AU",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"SPOTDOMAIN": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkSpotDomain",
		"CLIENT_ID": "10088",
		"CLIENT_PREFIX": "CPSPDM",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"ADDRESS": "Domain Car Park, woolloomooloo, NSW, AU",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"CATHEDRAL": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkCathedral",
		"CLIENT_ID": "10079",
		"CLIENT_PREFIX": "CPCAT",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/enacon/local_logo.png",
		"ADDRESS": "2 Cathedral St Sydney NSW 2000",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"INTERCONTINENTAL": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkIntercontinental",
		"CLIENT_ID": "10080",
		"CLIENT_PREFIX": "CPINT",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/enacon/local_logo.png",
		"ADDRESS": "117 Macquarie St Sydney NSW 2000",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"CHATSWOOD": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkChatswood",
		"CLIENT_ID": "10083",
		"CLIENT_PREFIX": "CPCHW",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/enacon/local_logo.png",
		"ADDRESS": "6 Brown St Chatswood",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"BELLAVISTA": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkBellavista",
		"CLIENT_ID": "10085",
		"CLIENT_PREFIX": "CPBLV",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/enacon/local_logo.png",
		"ADDRESS": "11 Norbrik Dr, Bella Vista NSW 2153",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"ARTSCENTER": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkArtscenter",
		"CLIENT_ID": "10086",
		"CLIENT_PREFIX": "CPATC",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"LOCAL_LOGO_PATH": "/carparks/local_logo_artscenter.png",
		"ADDRESS": "100 St Kilda Rd, Melbourne VIC 3004",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"EUREKATOWER": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkEurekatower",
		"CLIENT_ID": "10095",
		"CLIENT_PREFIX": "CPRKT",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"ADDRESS": "70 City Rd, Southbank VIC 3006",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"GRANDHYATT": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carparkGrandhyatt",
		"CLIENT_ID": "10096",
		"CLIENT_PREFIX": "CPGHY",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"ADDRESS": "128 Flinders Ln, Melbourne VIC 3000",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"32FLINDERS": {
		"PAGE_TITLE": "WipeHero - Carpark Wash Service",
		"CLIENT_NAME": "carpark32flinders",
		"CLIENT_ID": "10097",
		"CLIENT_PREFIX": "CPATC",
		"PAYMENT_TYPE": "POST",
		"LOGO_PATH": "/carparks/domain/logo.png",
		"ADDRESS": "32 Flinders St, Melbourne VIC 3000",
		"ALLOWED_WASH_TYPES": [
			"OUTIE",
			"SPECTO",
			"FULLO"
		]
	},
	"SMS": {
		"PAGE_TITLE": "WipeHero - SMS Booking Payment",
		"PAYMENT_TYPE": "PAYMENT_ONLY"
	},
	"WASH_TYPES": [
		{
			"name": "OUTIE",
			"displayName": "Silver",
			"subTitle": "Outside clean",
			"points": [
				"Quick Exterior Hand Wash",
				"Tyre Shine & Rim Wipedown",
				"Windows Cleaned (Outside Only)"
			]
		},
		{
			"name": "FULLO",
			"displayName": "Gold",
			"subTitle": "In & out clean",
			"points": [
				"Quick Exterior Hand Wash",
				"Tyre Shine & Rim Wipedown",
				"Windows Cleaned (Inside + Outside)",
				"Interior & Trunk Vacuum",
				"Inside Wipedown"
			]
		},
		{
			"name": "SPECTO",
			"displayName": "Platinum",
			"subTitle": "In & out clean and buff",
			"points": [
				"Detailed Exterior Hand Wash",
				"Tyre Shine & Rim Clean",
				"Windows Cleaned (Inside + Outside)",
				"Thorough Interior & Trunk Vacuum",
				"Inside Wipedown",
				"Bug & Tar Removal",
				"Complete Wax For Protect & Shine"
			]
		}
	],
	"BOOKING_STEPS": {
		"PRE": [
			"carDetails",
			"timeSlots",
			"preCustomerDetails",
			"creditcard",
			"preFinished"
		],
		"POST": [
			"postCustomerDetails",
			"timeSlots",
			"postFinished"
		]
	},
	"THEME_DEFAULT": {
		"fontFamily": "Raleway, Nunito, sans-serif",
		"palette": {
			"primary1Color": "#77bc1f",
			"primary2Color": "#005b74",
			"accent1Color": "#77bc1f"
		},
		"datePicker": {
			"selectColor": "#77bc1f"
		}
	},
	"THEME_MCCARROLLS": {
		"fontFamily": "Raleway, Nunito, sans-serif",
		"palette": {
			"primary1Color": "#000B27",
			"primary2Color": "#005b74",
			"accent1Color": "#a8a8a8"
		},
		"datePicker": {
			"selectColor": "#000B27"
		}
	},
	"STRIPE": {
		"TEST_API_KEY": "pk_test_xvbtPJuP8Wy3tyPMpUfNnaqV",
		"PROD_API_KEY": "pk_live_vVUEFH0anLBNLkCbUaR2qVrE"
	},
	"GOOGLE": {
		"API_KEY": "AIzaSyDatYWCPqsw3XwgAT8yihp6RVph8fgHhFo"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/app/config.json
// module id = 1021
// module chunks = 0